import React from 'react';
import { useState, useRef } from 'react';
import {
  postGroudingLite
} from "../../service/api";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from "@material-ui/core/styles";
import LinearProgress from '@material-ui/core/LinearProgress';
import DoneIcon from '@material-ui/icons/Done';
import {getElementPayload} from '../../Utils/utils';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Box, Button } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles({
  fileUploadHeading: {
    fontSize: '22px',
    fontWeight: 'bold',
    background: 'white',
    height: '66px',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  uploadProgress: {
    textAlign: 'center',
    padding: '60px'
  },
  uploadProgressContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center'
  },
  fullWidth: {
    width: '100%',

  },
  progressBarHeight: {
    height: '4px !important'
  },
  progressElements: {
    display: 'flex',
    flexDirection: 'row',
    borderRadius: '2rem',
    alignItems: 'center',
    padding: '2px'
  },
  circleProgress: {
    width: '32px',
    height: '32px',
    border: '2px solid #e1e1e1',
    borderRadius: '50%',
    padding: '2px'
  },
  progressElementTab: {
    fontSize: '16px',
    fontWeight: '600',
    width: '70px',
  },
  complete: {
    border: '2px solid #fff',
    background: '#00C6B7',
    color: '#fff'
  },
  initial: {
    border: '2px solid #e1e1e1',
    background: '#fff',
    color: '#000'
  },
  filedataContainer: {
    textAlign: 'center'
  },
  fileUploadHeader: {
    fontSize: '16px',
    fontWeight: 'bold',
  },
  table: {
    border: "1px solid #e1e1e1",
  },
  tableRow: {
    borderBottom: "1px solid #e1e1e1",
  },
  tableHeaderRow: {
    borderTop: "1px solid #e1e1e1",
    borderBottom: "1px solid #e1e1e1",
  },
  btnUpload: {
    width: '140px',
    height: '32px',
    margin: '0 8px 0 0',
    padding: '1px 6px 1px 7px',
    borderRadius: '4px',
    border: 'solid 1px #0070d2 !important',
    fontSize: '0.87rem !important',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.5 !important',
    background: '#fff'
  },

});

export const CsvReader = ({ setFileUpload, setDataVerifed, submitResult }) => {
  const [currentFile, setCurrentFile] = useState();
  const [currentFileData, setCurrentFileData] = useState([]);
  const [errorFile, setErrorFile] = useState(false);
  const [, setLoading] = useState(false);
  const classes = useStyles();
  const processCSV = async (str, delim = ',') => {
    const headers = str.slice(0, str.indexOf('\n')).split(delim);
    const rows = str.slice(str.indexOf('\n') + 1).split('\n');
    const newArray = rows.map(row => {
      const values = row.split(delim);
      const eachObject = headers.reduce((obj, header, i) => {
        if (header) {
          if(headers?.length - 1 === i && headers[i].indexOf('LocationNotes') >= 0) {
            obj['LocationNotes'] = values[i];
          } else {
            obj[header] = values[i];
          }
        }
        return obj;
      }, {})
      return eachObject;
    })
    setDataVerifed(true)
    setCurrentFileData(newArray)
  }


  const submit = async () => {
    let tempNum = 0;
    currentFileData.forEach(async (element, index) => {
      if (element.VIN === '') {
        currentFileData.splice(index, 1)
      } else {
        const payload = getElementPayload(element);
        currentFileData[index].status = 'loading';
        const vehicleInspectionDetails = await postGroudingLite(payload);
        if (vehicleInspectionDetails?.data) {
          tempNum++;
          currentFileData[index].status = vehicleInspectionDetails?.data?.GroundingID !== 0 ? `${vehicleInspectionDetails?.data?.GroundingID}-${vehicleInspectionDetails?.data?.ResponseMessage}` : vehicleInspectionDetails?.data?.ResponseMessage || 'Done';
          if (tempNum === currentFileData?.length) {
            setLoading(false)
            submitResult(100)
          }
        }
      }
    });
    setCurrentFileData(currentFileData)
  }

  const integrateData = (file) => {
    if (file?.name.indexOf('.csv') > 0) {
      setErrorFile(false)
      const reader = new FileReader();

      reader.onload = function (e) {
        const text = e.target.result;
        processCSV(text)
      }

      reader.readAsText(file);
    } else {
      setErrorFile(true)
    }
  }
  const fileUploadRef = useRef();
  const resetValue = () => {
    setCurrentFile();
    setCurrentFileData([]);
    setErrorFile(false);
    setFileUpload(0);
    setDataVerifed(false);
    submitResult(0);
    if(fileUploadRef?.current?.value) {
      fileUploadRef.current.value = '';
    }
  }

  const handleClick = event => {
    event.preventDefault();
    if(currentFile) resetValue();
    fileUploadRef.current.click();
  };
  return (
    <div>
      <div>
      <form id='csv-form'>
        <div className={classes.parentDiv}>
          <div>
          <button className={classes.btnUpload} onClick={handleClick} >Choose file</button>
          <input
            type='file'
            ref={fileUploadRef}
            accept='.csv'
            id='currentFile'
            onChange={(e) => {
              setCurrentFile(e.target.files[0]);
              if (e.target.files[0]) setFileUpload(100);
              integrateData(e.target.files[0]);
            }}
            style={{display: 'none'}}
          />
          <label>{currentFile?.name}</label>
          </div>
       
          <div>Download Sample File <a download='Bulk Inventory Upload.csv' href="BulkInventoryUpload.csv" >Here</a></div>
        </div>
        <br />
        {errorFile && <><div style={{ color: 'red' }}>Please Upload CSV File Only</div> <br /></>}
        <br />
        <br />
      </form>
      </div>
      {currentFile && <div id='dataFileTable'>
        <label className={classes.fileUploadHeader}> Vehicle Inventory List </label>
        {currentFileData?.length > 0 &&
          <TableContainer component={Paper}>
            <Table className={classes.table} sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead className={classes.tableHeaderRow}>
                <TableRow className={classes.tableHeadFont}>
                  <TableCell>VIN</TableCell>
                  <TableCell align="left">Brand</TableCell>
                  <TableCell align="left">Model</TableCell>
                  <TableCell align="left">Model Year</TableCell>
                  <TableCell align="right">Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {currentFileData.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {row.VIN}
                    </TableCell>
                    <TableCell align="left">{row.Brand}</TableCell>
                    <TableCell align="left">{row.Model}</TableCell>
                    <TableCell align="left">{row.ModelYear}</TableCell>
                    <TableCell align="right">
                      {(row?.status === 'loading') ?
                        <CircularProgress style={{ height: '16px', width: '16px' }} /> : row?.status
                      }
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        }
        <Box m={2} justifyContent="flex-end" display={'flex'}
          sx={{
            "& .MuiButton-root": {
              m: 5
            }
          }}>
          <div style={{ paddingRight: '16px' }}>
            <Button
              className={`passButton ${classes.buttonHandle}`}
              color="primary"
              onClick={() => {
                resetValue();
              }}
            >
              Cancel
            </Button>
          </div>
          <div>
            <Button
              className={`purchaseButton ${classes.buttonHandle}`}
              color="primary"
              onClick={(e) => {
                e.preventDefault()
                if (currentFile) submit()
              }}
            >
              Upload
            </Button>
          </div>
        </Box>
      </div>
      }
    </div>
  );

}

export const UploadProgress = ({ uploadData, verifydata, submitProgress }) => {
  const classes = useStyles();
  return (
    <div className={classes.uploadProgressContainer}>
      <div className={`${classes.progressElements} ${uploadData === 100 ? classes.complete : classes.initial}`}>
        <div className={classes.circleProgress}>
          {uploadData === 0 ? 1 : <DoneIcon />}
        </div>
        <div className={classes.progressElementTab}>Upload</div>
      </div>
      <div className={classes.fullWidth}>
        <LinearProgress className={classes.progressBarHeight} variant="determinate" value={uploadData} />
      </div>
      <div className={`${classes.progressElements} ${verifydata ? classes.complete : classes.initial}`}>
        <div className={classes.circleProgress}>
          {!verifydata ? 2 : <DoneIcon />}
        </div>
        <div className={classes.progressElementTab}>Verify</div>
      </div>
      <div className={classes.fullWidth}>
        <LinearProgress className={classes.progressBarHeight} variant="determinate" value={submitProgress} />
      </div>
      <div className={`${classes.progressElements} ${submitProgress === 100 ? classes.complete : classes.initial}`}>
        <div className={classes.circleProgress}>
          {submitProgress === 0 ? 3 : <DoneIcon />}
        </div>
        <div className={classes.progressElementTab}>Submit</div>
      </div>
    </div>
  )
}


export const FileUpload = () => {
  const classes = useStyles();
  const [uploadData, setUploadData] = useState(0);
  const [submitProgress, setSubmitProgress] = useState(0);
  const [verifydata, setVerifydata] = useState(false);
  const value = 0;
  return (
    <div style={{ marginTop: '50px' }}>
      <AppBar position="inherit" className='topBarAdmin'>
        <Tabs value={value}  aria-label="simple tabs example" className='tabset'>
          <Tab label="Upload Vehicle Inventory" />
        </Tabs>
      </AppBar>
      <div className={classes.uploadProgress}>
        <UploadProgress initialData={false} uploadData={uploadData} verifydata={verifydata} submitProgress={submitProgress} />
      </div>
      <div className={classes.filedataContainer}>
        <CsvReader setFileUpload={setUploadData} setDataVerifed={setVerifydata} submitResult={setSubmitProgress} />
      </div>
    </div>
  )
};

export default FileUpload;